var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","hasAcceptRGPD":_vm.gethasRGPD}},[(_vm.getLogged)?_c('app-header'):_vm._e(),_vm._v(" "),_c('router-view',{attrs:{"logged":_vm.getLogged}}),_vm._v(" "),(_vm.$route.name != 'login')?_c('app-footer'):_vm._e(),_vm._v(" "),_c('popup-encuestas'),_vm._v(" "),_c('popup-errores')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b075c2d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 